<template>
	<b-row class="mt-5">
		<b-col cols="12" class="button-actions mb-3"
			v-if="(proposal.psal_approval_code == 'pending_accept') && !is_expired_or_not_exist_link">
			<b-form-group label="Proposal under waiting client acceptance, Share the link to client esign and approval process"
				label-cols="12" content-cols="12">
				<b-input-group class="mb-2">
					<b-form-input v-model="esign_link" type="text" readonly></b-form-input>
					<b-input-group-append>
						<b-button variant="primary" class="px-5" @click="copyLink(esign_link)">
							<b-icon icon="files" aria-hidden="true"></b-icon>
							Copy
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-form-group>
			<b-form-group class="mt-0" label-cols="12" v-if="!_gHlp.isEmpty(unsigned_proposal_file)">
				<!-- <h3 class="mb-0 d-flex align-items-center">
									<span class="badge bg-secondary px-2 mr-1" v-if="is_new_customer">Option 1</span> 
									<span class="badge bg-secondary px-2 mr-1" v-else>Option 2</span> 
									Manual
							</h3> -->
				<el-button type="text" @click="_gFile.downloadFromAttachmnetService(unsigned_proposal_file.attachment_id,unsigned_proposal_file.original_filename)"><b-icon icon="cloud-download-fill" font-scale="1.2"></b-icon> Download Unsigned Proposal</el-button>
				<vue-dropzone id="proposalDropzone" ref="proposalDropzone" :options="dropzoneOptions" :useCustomSlot=true
					v-on:vdropzone-error="dropzoneError" v-on:vdropzone-file-added="dropzoneAdded"
					v-on:vdropzone-removed-file="dropzoneRemoved">
					<b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
					<p class="mb-0">Drop files here</p>
				</vue-dropzone>
				<small class="text-danger">Manual proposal will override Esign.</small>
			</b-form-group>
		</b-col>
		<b-col cols="12" class="text-center">
			<el-button class="px-5 mb-3" type="primary" @click="createProposalCase" :loading="btn_create_case_loading"
				:disabled="!can_create_case"
				v-if="proposal.psal_main_status !== 'Converted to Case'">Create
				Case</el-button>
			<el-button class="px-5 mb-3" type="danger" @click="manualAcceptedByClient" :loading="btn_accept_loading"
				v-if="(proposal.psal_approval_code == 'pending_accept') && !is_expired_or_not_exist_link">Accept By
				Client</el-button>
			<el-button class="px-5 mb-3" type="success" :loading="btn_generate_loading"
				v-if="(proposal.psal_approval_code == 'pending_accept')"
				@click="generateLink()">Generate Acceptance Link</el-button>
			<!-- <b-button class="px-5 mb-3" variant="outline-primary" >Generate Invoice</b-button> -->
		</b-col>
	</b-row>
</template>
<style>
#proposalDropzone.dropzone .dz-preview .dz-progress {
	display: none !important
}
</style>
<script>
import { Button } from 'element-ui'
import vue2Dropzone, { methods } from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { axios, services, getHeader, getKycHeader } from '@/assets/js/httpImports.js'
import { IP_APPROVED_STATUSES } from '@/assets/js/status.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import _ from 'lodash'

export default {
	props: ['proposal'],
	components: {
		vueDropzone: vue2Dropzone,
		[Button.name]: Button
	},
	data() {
		return {
			manual_proposal_file: null,
			unsigned_proposal_file: null,
			is_loading: false,
			btn_generate_loading: false,
			btn_accept_loading: false,
			btn_create_case_loading: false,
			esign_link: this.proposal.client_approval.link,
			IP_APPROVED_STATUSES: IP_APPROVED_STATUSES,
			failed_cases: [],
			dropzoneOptions: {
				url: '#',
				addRemoveLinks: true,
				maxFiles: 1,
				autoProcessQueue: false,
				acceptedFiles: "application/pdf,image/jpeg,image/png",
			},
		}
	},
	computed: {
		is_editable() {
			return !IP_APPROVED_STATUSES.includes(this.proposal.psal_main_status)
		},
		is_expired_or_not_exist_link() {
			return _gHlp.isEmpty(this.proposal.client_approval.link) || this.proposal.client_approval.is_expired
		},
		can_create_case(){
			return this.proposal.psal_approval_code == 'accepted';
		}
	},
	mounted() {
		// initialProposalEventBus.$on('show-proposal', this.getCustomerVariableExpenses)
	},
	watch: {
		proposal(newVal) {
			if (newVal) {
				this.esign_link = newVal.client_approval.link;
			}
		}
	},
	created() {
		this.setUnsignedProposalLink();
	},
	methods: {
		copyLink(url) {
			_gHlp.copyToClipboard(url)
			_gNotif.notifySuccess('CLient Approval link copied.')
		},
		async generateLink() {
			this.btn_generate_loading = true
			axios.post(services.initial_proposal + 'proposal/generate-approval-link/' + this.proposal.psal_id, {}, { headers: getHeader() })
				.then(res => {
					this.btn_generate_loading = false
					_gNotif.notifySuccess('<b>Proposal Case:</b> - Client approval link successfully generated.')
					initialProposalEventBus.$emit('refresh-proposal-detail')
				})
				.catch(e => {
					this.btn_generate_loading = false
					_gNotif.errorFunction(e)
				})
		},
		setUnsignedProposalLink(){
			this.unsigned_proposal_file = _.find(this.proposal.appendixes, (o)=>{ return o.papp_type == 'PROPOSAL'; });
		},
		dropzoneError(file, error, xhr) {
			this.manual_proposal_file = null
		},
		dropzoneAdded(file) {
			this.manual_proposal_file = file
		},
		dropzoneRemoved(file, error, xhr) {
			this.manual_proposal_file = null
		},
		async createProposalCase() {
			this.btn_create_case_loading = true
			const ProductApplications = _gHlp.getValue(this.proposal,'product_applications',[]);
			if(_gHlp.isEmpty(ProductApplications)) {
				_gNotif.errorFunction(null, '<b>Proposal Case</b> - Proposal not have selected product.')
				return false
			}

			this.is_loading = true
			for (let i = 0; i < ProductApplications.length; i++) {
				const product_application = this.proposal.product_applications[i]
				const product_type = product_application.pcom_product_detail.pcp_product_type.toLowerCase()
				switch (product_type) {
					case 'property':
						await this.createPropertyCase(product_application)
						break;
					case 'personal_loan':
						await this.createPersonalLoanCase(product_application)
						break;
					case 'mortgage':
						await this.createMortgageLoanCase(product_application)
						break;
					case 'insurance':
						await this.createInsuranceCase(product_application)
						break;
					case 'refinance':
						await this.createRefinanceCase(product_application)
						break;
					case 'other':
						await this.createOtherCase(product_application)
						break;
				}
				this.btn_create_case_loading = false
			}

			let data = {
				psal_customer_id: this.proposal.psal_customer_id,
				psal_main_status: 'Converted to Case',
				psal_sub_status: 'Converted to Case',
			}

			axios.post(services.initial_proposal + 'proposal/' + this.proposal.psal_id, data, { headers: getHeader() })
				.then(res => {
					console.log(this.failed_cases)
					if (this.failed_cases.length === 0) {
						_gNotif.notifySuccess('<b>Proposal Case:</b> - Successfully Created.')
					} else {
						_gNotif.errorFunction(null, '<b>Proposal Case</b> - Created. <br>Failed to create ' + this.failed_cases.length + ' case(s). <br>Please create it manually.')
					}
					this.is_loading = false
					this.failed_cases = []
					initialProposalEventBus.$emit('refresh-proposal-detail')
				})
				.catch(e => {
					this.is_loading = false
					this.failed_cases = []
					_gNotif.errorFunction(e)
				})
		},
		async createOtherCase(product_application) {
			let pcp_project_json = product_application.pcom_product_detail.pcp_project_json
			let data = {
				"prod_customer_id": this.customer.customer_id,
				"prod_customer_name": this.customer.name,
				"prod_customer_basket": this.customer.basket.basket_color,
				"prod_type": "other",
				"prod_agent_id": this.customer.se.id,
				"prod_agent_username": this.customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Application Pending",
				"prod_status": "Application Pending",
				"prod_custom_identifier": 'case_other-customer_' + this.customer.customer_id,
				"product_detail": {
					"prod_oth_type": pcp_project_json.prod_oth_type,
					"prod_oth_detail": pcp_project_json.prod_oth_detail,
					"prod_oth_value": pcp_project_json.prod_oth_value,
					"prod_oth_pay_mode": pcp_project_json.prod_oth_pay_mode,
					"prod_oth_agreement_rate": pcp_project_json.prod_oth_agreement_rate,
					"prod_oth_agreement_rate_sst": pcp_project_json.prod_oth_agreement_rate_sst,
					"prod_oth_agreement_fees": pcp_project_json.prod_oth_agreement_fees
				},
			}

			try {
				await axios.post(services.product + 'product', data, { headers: getHeader() })
			} catch (e) {
				this.failed_cases.push('Other Loan')
			}
		},
		async createInsuranceCase(product_application) {
			let pcp_project_json = product_application.pcom_product_detail.pcp_project_json
			let data = {
				"prod_customer_id": this.customer.customer_id,
				"prod_customer_name": this.customer.name,
				"prod_customer_basket": this.customer.basket.basket_color,
				"prod_type": "insurance",
				"prod_agent_id": this.customer.se.id,
				"prod_agent_username": this.customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Application Pending",
				"prod_status": "Application Pending",
				"prod_custom_identifier": 'case_insurance-customer_' + this.customer.customer_id,
				"product_detail": {
					"prod_ins_type": pcp_project_json.prod_ins_type,
					"prod_ins_package": pcp_project_json.prod_ins_package,
					"prod_ins_company": pcp_project_json.prod_ins_company,
					"prod_ins_premium_pa": pcp_project_json.prod_ins_premium_pa,
					"prod_ins_premium_pm": pcp_project_json.prod_ins_premium_pm,
					"prod_ins_premium_cover": pcp_project_json.prod_ins_premium_cover,
					"prod_ins_paid_by": pcp_project_json.prod_ins_paid_by
				},
			}

			try {
				await axios.post(services.product + 'product', data, { headers: getHeader() })
			} catch (e) {
				this.failed_cases.push('Insurance')
			}
		},
		async createPersonalLoanCase(product_application) {
			const bank = this.banks.find(bank => bank.bank_code == product_application.pcom_bank_code)

			let data = {
				"prod_customer_id": this.customer.customer_id,
				"prod_customer_name": this.customer.name,
				"prod_customer_basket": this.customer.basket.basket_color,
				"prod_type": "personal_loan",
				"prod_agent_id": this.customer.se.id,
				"prod_agent_username": this.customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Application Pending",
				"prod_status": "Application Pending",
				"prod_custom_identifier": 'case_personal_loan-customer_' + this.customer.customer_id,
				"product_detail": {
					"prod_pl_stage_status": "Pending",
					"prod_pl_loan_amount": product_application.pcom_product_detail.pcp_loan_amount,
					"prod_pl_interest": product_application.pcom_product_detail.pcp_interest_rate,
					"prod_pl_tenure": product_application.pcom_product_detail.pcp_tenure,
					"prod_pl_installment": product_application.pcom_product_detail.pcp_monthly_installment,
					"prod_pl_loan_agreement_fees": product_application.pcom_product_detail.pcp_arragement_fee_amount,
					"prod_pl_loan_agreement_rate": product_application.pcom_product_detail.pcp_arragement_fee_rate,
					"prod_pl_loan_agreement_rate_sst": product_application.pcom_product_detail.pcp_arragement_fee_rate_sst,
				},
				"product_banks": [
					{
						"prod_bnk_name": product_application.pcom_bank_name,
						"prod_bnk_logo_url": bank ? bank.bank_image_url : null,
						"prod_bnk_stage_status": "Pending Submission",
						"prod_bnk_loan_amount": product_application.pcom_product_detail.pcp_loan_amount,
						"prod_bnk_interest": product_application.pcom_product_detail.pcp_interest_rate,
						"prod_bnk_tenure": product_application.pcom_product_detail.pcp_tenure,
						"prod_bnk_gross_cashback": product_application.pcom_product_detail.pcp_cash_back_amount,
						"prod_bnk_installment": product_application.pcom_product_detail.pcp_monthly_installment,
						"prod_bnk_code": product_application.pcom_bank_code,
					}
				]
			}

			try {
				await axios.post(services.product + 'product', data, { headers: getHeader() })
			} catch (e) {
				this.failed_cases.push('Personal Loan: ' + product_application.pcom_product_detail.pcp_project_name)
			}
		},
		async createMortgageLoanCase(product_application) {
			const bank = this.banks.find(bank => bank.bank_code == product_application.pcom_bank_code)

			let data = {
				"prod_customer_id": this.customer.customer_id,
				"prod_customer_name": this.customer.name,
				"prod_customer_basket": this.customer.basket.basket_color,
				"prod_type": "mortgage",
				"prod_agent_id": this.customer.se.id,
				"prod_agent_username": this.customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Application Pending",
				"prod_status": "Application Pending",
				"prod_custom_identifier": 'case_mortgage-customer_' + this.customer.customer_id,
				"product_detail": {
					"prod_pm_project_name": product_application.pcom_product_detail.pcp_project_name,
					"prod_pm_unit_no": product_application.pcom_product_detail.pcp_project_unit_no,
					"prod_pm_property_type": product_application.pcom_product_detail.pcp_project_type,
					"prod_pm_loan_agreement_fees": product_application.pcom_product_detail.pcp_arragement_fee_amount,
					"prod_pm_loan_agreement_rate": product_application.pcom_product_detail.pcp_arragement_fee_rate,
					"prod_pm_loan_agreement_rate_sst": product_application.pcom_product_detail.pcp_arragement_fee_rate_sst,
				},
				"product_banks": [
					{
						"prod_bnk_name": product_application.pcom_bank_name,
						"prod_bnk_logo_url": bank ? bank.bank_image_url : null,
						"prod_bnk_stage_status": "Pending Submission",
						"prod_bnk_loan_amount": product_application.pcom_product_detail.pcp_loan_amount,
						"prod_bnk_spa_amount": product_application.pcom_product_detail.pcp_spa_amount,
						"prod_bnk_interest": product_application.pcom_product_detail.pcp_interest_rate,
						"prod_bnk_margin": product_application.pcom_product_detail.pcp_margin_finance,
						"prod_bnk_tenure": product_application.pcom_product_detail.pcp_tenure,
						"prod_bnk_gross_cashback": product_application.pcom_product_detail.pcp_cash_back_amount,
						"prod_bnk_installment": product_application.pcom_product_detail.pcp_monthly_installment,
						"prod_bnk_code": product_application.pcom_bank_code,
					}
				]
			}

			try {
				await axios.post(services.product + 'product', data, { headers: getHeader() })
			} catch (e) {
				this.failed_cases.push('Mortgage: ' + product_application.pcom_product_detail.pcp_project_name)
			}
		},
		async createRefinanceCase(product_application) {
			const bank = this.banks.find(bank => bank.bank_code == product_application.pcom_bank_code)
			let data = {
				"prod_customer_id": this.customer.customer_id,
				"prod_customer_name": this.customer.name,
				"prod_customer_basket": this.customer.basket.basket_color,
				"prod_type": "refinance",
				"prod_agent_id": this.customer.se.id,
				"prod_agent_username": this.customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Application Pending",
				"prod_status": "Application Pending",
				"prod_custom_identifier": 'case_refinance-customer_' + this.customer.customer_id,
				"product_detail": {
					"prod_ref_stage_status": "Pending",
					"prod_ref_project_name": null,
					"prod_ref_remortgage_amount": product_application.pcom_product_detail.pcp_project_json.prod_ref_remortgage_amount,
					"prod_ref_loan_amount": product_application.pcom_product_detail.pcp_loan_amount,
					"prod_ref_interest": product_application.pcom_product_detail.pcp_interest_rate,
					"prod_ref_margin": product_application.pcom_product_detail.pcp_margin_finance,
					"prod_ref_tenure": product_application.pcom_product_detail.pcp_tenure,
					"prod_ref_installment": product_application.pcom_product_detail.pcp_monthly_installment,
					"prod_ref_bank_outstanding": product_application.pcom_product_detail.pcp_project_json.prod_ref_bank_outstanding,
					"prod_ref_cashout_amount": product_application.pcom_product_detail.pcp_project_json.prod_ref_cashout_amount,
					"prod_ref_agreement_rate": product_application.pcom_product_detail.pcp_arragement_fee_rate,
					"prod_ref_agreement_rate_sst": product_application.pcom_product_detail.pcp_arragement_fee_rate_sst,
					"prod_ref_agreement_fees": product_application.pcom_product_detail.pcp_arragement_fee_amount,
				},
				"product_banks": [
					{
						"prod_bnk_name": product_application.pcom_bank_name,
						"prod_bnk_logo_url": bank ? bank.bank_image_url : null,
						"prod_bnk_stage_status": "Pending Submission",
						"prod_bnk_loan_amount": product_application.pcom_product_detail.pcp_loan_amount,
						"prod_bnk_interest": product_application.pcom_product_detail.pcp_interest_rate,
						"prod_bnk_margin": product_application.pcom_product_detail.pcp_margin_finance,
						"prod_bnk_tenure": product_application.pcom_product_detail.pcp_tenure,
						"prod_bnk_gross_cashback": product_application.pcom_product_detail.pcp_cash_back_amount,
						"prod_bnk_installment": product_application.pcom_product_detail.pcp_monthly_installment,
						"prod_bnk_code": product_application.pcom_bank_code,
					}
				]
			}

			try {
				await axios.post(services.product + 'product', data, { headers: getHeader() })
			} catch (e) {
				this.failed_cases.push('Refinance: ' + product_application.pcom_product_detail.pcp_project_name)
			}
		},
		async createPropertyCase(product_application) {
			const bank = this.banks.find(bank => bank.bank_code == product_application.pcom_bank_code)

			let data = {
				"prod_customer_id": this.customer.customer_id,
				"prod_customer_name": this.customer.name,
				"prod_customer_basket": this.customer.basket.basket_color,
				"prod_type": "property",
				"prod_agent_id": this.customer.se.id,
				"prod_agent_username": this.customer.se.name,
				"prod_agent_company": null,
				"prod_main_status": "Application Pending",
				"prod_status": "Application Pending",
				"prod_image_url": product_application.pcom_product_detail.pcp_project_image_url,
				"prod_custom_identifier": 'case_project-customer_' + this.customer.customer_id,
				"product_detail": {
					"prod_pm_property_id": product_application.pcom_product_detail.pcp_project_id,
					"prod_pm_project_name": product_application.pcom_product_detail.pcp_project_name,
					"prod_pm_property_type": product_application.pcom_product_detail.pcp_project_type,
					"prod_pm_lease_type": product_application.pcom_product_detail.prod_pm_lease_type,
					"prod_pm_benefits": null,
					"prod_pm_unit_id": product_application.pcom_product_detail.pcp_unit_id,
					"prod_pm_unit_no": product_application.pcom_product_detail.pcp_project_unit_no,
					"prod_pm_spa_price": product_application.pcom_product_detail.pcp_spa_amount,
					"prod_pm_net_buyer_discount": product_application.pcom_product_detail.pcp_client_net_amount,
					"prod_pm_buyer_discount": product_application.pcom_product_detail.pcp_rebate_rate,
					"prod_pm_cashback": product_application.pcom_product_detail.pcp_cash_back_amount,

					"prod_pm_property_size": product_application.pcom_product_detail.pcp_project_json.sqft,
					"prod_pm_sp_agreement_fee": product_application.pcom_product_detail.pcp_project_json.fees_spa_legal_fee,
					"prod_pm_mot_fees": product_application.pcom_product_detail.pcp_project_json.fees_mot,
					"prod_pm_total_fees": product_application.pcom_product_detail.pcp_project_json.fees_total,
					"prod_pm_loan_agreement_fees": product_application.pcom_product_detail.pcp_project_json.fees_loan_legal_fee,
					"prod_pm_maintenance_fees": product_application.pcom_product_detail.pcp_project_json.fees_maintenance,
					"prod_pm_loan_stamp_duty": product_application.pcom_product_detail.pcp_project_json.fees_loan_legal_fee,
					"prod_pm_sinking_fund": product_application.pcom_product_detail.pcp_project_json.fees_sinking_fund
				},
				"product_banks": [
					{
						"prod_bnk_name": product_application.pcom_bank_name,
						"prod_bnk_logo_url": bank ? bank.bank_image_url : null,
						"prod_bnk_banker_id": null,
						"prod_bnk_stage_status": "Pending Submission",
						"prod_bnk_loan_amount": product_application.pcom_product_detail.pcp_loan_amount,
						"prod_bnk_spa_amount": product_application.pcom_product_detail.pcp_spa_amount,
						"prod_bnk_interest": product_application.pcom_product_detail.pcp_interest_rate,
						"prod_bnk_margin": product_application.pcom_product_detail.pcp_margin_finance,
						"prod_bnk_tenure": product_application.pcom_product_detail.pcp_tenure,
						"prod_bnk_gross_cashback": product_application.pcom_product_detail.pcp_cash_back_amount,
						"prod_bnk_installment": product_application.pcom_product_detail.pcp_monthly_installment,
						"prod_bnk_code": product_application.pcom_bank_code,
					}
				]
			}
			try {
				await this.checkCanCreatePMPCase(this.customer.customer_id, product_application.pcom_product_detail.pcp_unit_id)
				await axios.post(services.product + 'product', data, { headers: getHeader() })
			} catch (e) {
				this.failed_cases.push('Property: ' + product_application.pcom_product_detail.pcp_project_name)
			}
		},
		async manualAcceptedByClient() {
			if (!this.manual_proposal_file) {
				_gNotify.errorFunction(null, 'Manual signed proposal is required.')
				return
			}

			let message = "Are you sure to manualy accpet by client this proposal ?";
			if (confirm(message) == true) {
				this.is_loading = true;
				let form = {
					"psal_manual_proposal": await _gHlp.convertFileToBase64(this.manual_proposal_file)
				}

				axios.post(services.initial_proposal + 'proposal/upload-signed-proposal/' + this.proposal.psal_id, form, { headers: getHeader() })
				.then(res => {
					this.is_loading = false;
					_gNotif.notifySuccess('<b>Proposal Case:</b> - Successfully Accepted By Client.')
					initialProposalEventBus.$emit('refresh-proposal-detail')
				})
				.catch(e => {
					this.is_loading = false;
					_gNotif.errorFunction(e)
				})
			}
		}
	}
}
</script>